import * as React from "react";

import s from "./LoadingComponent.module.scss";
import { Sendum } from "../../Sendum";

interface LoadingComponentPropsI {
	loading?: boolean;
	text?: string;
	className?: string;
}

const LoadingComponent = ({ loading, text, className }: LoadingComponentPropsI) => {
	if (!loading) {
		return null;
	}
	const Loader = Sendum.getLoader() as any;

	if (Loader) {
		return <div className={s.customLoader}><Loader open text={text || "Loading..."}/></div>;
	}

	return (
		<div className={[s.loading, className].join(" ")}>
			<div className={s.loading__row}>
				<h1 className={s.loading__title}>{text || "Loading..."}</h1>
			</div>
		</div>
	);

};

export default LoadingComponent;
